import { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import API from "../Network/API";
import UserAvatar from "../components/UserAvatar";
import MeetingFrame from "../components/MeetingFrame";
import "./Tutor/LiveRoom/LiveRoom.css";

// xller.com/live/{code}: a teacher's shared Live Room. Signed-in users only.
export default function LiveJoin() {
    const { t } = useTranslation();
    const { code } = useParams();
    const location = useLocation();
    const { user, accessToken } = useSelector((state) => state.authReducer);
    const prefix = location.pathname.startsWith("/app") ? "/app" : "";

    const [state, setState] = useState(accessToken ? "loading" : "signin");
    const [room, setRoom] = useState(null);

    useEffect(() => {
        if (!accessToken) return;
        setState("loading");
        API.get(`/v1/oauth/live-room/${code}`)
            .then((response) => { setRoom(response.data.data); setState("live"); })
            .catch((err) => {
                const status = err?.response?.status;
                setRoom(err?.response?.data?.errors || null);
                setState(status === 410 ? "ended" : status === 401 ? "signin" : "invalid");
            });
    }, [code, accessToken]);

    const loginUrl = `${prefix}/login?redirect=${encodeURIComponent(`${prefix}/live/${code}`)}`;
    const dashboard = user?.role === "teacher" ? `${prefix}/dashboard/tutor` : `${prefix}/home/student`;

    const Host = () => room?.host ? (
        <div className="lj-host">
            <UserAvatar src={room.host.avatar} name={room.host.name} size={44} />
            <div>
                <span>{t("liveJoin.hosted_by")}</span>
                <strong>{room.host.name}</strong>
            </div>
        </div>
    ) : null;

    if (state === "live") {
        return (
            <div className="lj-page container">
                <div className="lj-bar">
                    <div className="lj-bar-main">
                        <span className="lr-live-dot" />
                        <div>
                            <h4>{room.title || t("liveRoom.untitled")}</h4>
                            <span>{t("liveJoin.started_at", { time: moment(room.started_at).format("h:mm A") })}</span>
                        </div>
                    </div>
                    <Host />
                </div>
                <div className="lr-meeting">
                    <MeetingFrame roomName={room.jitsi_room} displayName={user?.name} isHost={room.is_host} height={620} />
                </div>
            </div>
        );
    }

    return (
        <div className="lj-page container">
            <div className="lj-card">
                {state === "loading" &&
                    <><span className="spinner-border lj-spinner" /><h4>{t("liveJoin.joining")}</h4></>
                }
                {state === "signin" &&
                    <>
                        <i className="fa-light fa-video lj-icon" />
                        <h4>{t("liveJoin.signin_title")}</h4>
                        <p>{t("liveJoin.signin_text")}</p>
                        <div className="lj-actions">
                            <Link to={loginUrl} className="btn lr-btn-primary">{t("liveJoin.sign_in")}</Link>
                            <Link to="/signup-student" className="btn lr-btn-ghost">{t("liveJoin.create_account")}</Link>
                        </div>
                    </>
                }
                {state === "ended" &&
                    <>
                        <i className="fa-light fa-circle-stop lj-icon is-muted" />
                        <h4>{t("liveJoin.ended_title")}</h4>
                        <Host />
                        <p>{t("liveJoin.ended_text")}</p>
                        <Link to={dashboard} className="btn lr-btn-primary">{t("liveJoin.back_dashboard")}</Link>
                    </>
                }
                {state === "invalid" &&
                    <>
                        <i className="fa-light fa-link-slash lj-icon is-muted" />
                        <h4>{t("liveJoin.invalid_title")}</h4>
                        <p>{t("liveJoin.invalid_text")}</p>
                        <Link to={dashboard} className="btn lr-btn-primary">{t("liveJoin.back_dashboard")}</Link>
                    </>
                }
            </div>
        </div>
    );
}
